/**
 * PaymentTiming enum — synced with backend C# enum.
 * Backend is the single source of truth. Numeric values must match exactly for API serialization.
 */
export enum PaymentTiming {
  Unknown = 0,
  BeforeFulfillment = 1,
  AtDelivery = 2,
  AtPickup = 3,
}

export const PaymentTimingLabel: Record<PaymentTiming, string> = {
  [PaymentTiming.Unknown]: "Unknown",
  [PaymentTiming.BeforeFulfillment]: "Before Fulfillment",
  [PaymentTiming.AtDelivery]: "At Delivery",
  [PaymentTiming.AtPickup]: "At Pickup",
}

/** Parse API value (number, string, or `{ id, code, name }`) to PaymentTiming. Returns Unknown for invalid values. */
export function parsePaymentTiming(value: unknown): PaymentTiming {
  if (typeof value === "number" && Number.isInteger(value)) {
    if (value >= PaymentTiming.BeforeFulfillment && value <= PaymentTiming.AtPickup) {
      return value as PaymentTiming
    }
    return PaymentTiming.Unknown
  }
  if (typeof value === "string") {
    const normalized = value.trim()
    const byName: Record<string, PaymentTiming> = {
      Unknown: PaymentTiming.Unknown,
      BeforeFulfillment: PaymentTiming.BeforeFulfillment,
      AtDelivery: PaymentTiming.AtDelivery,
      AtPickup: PaymentTiming.AtPickup,
    }
    if (byName[normalized] !== undefined) return byName[normalized]
    const num = parseInt(normalized, 10)
    if (!Number.isNaN(num) && num >= 1 && num <= 3) return num as PaymentTiming
  }
  if (value != null && typeof value === "object" && !Array.isArray(value)) {
    const block = value as Record<string, unknown>
    return parsePaymentTiming(block.code ?? block.value ?? block.name ?? block.id)
  }
  return PaymentTiming.Unknown
}
